// Recover from stale dynamic-import chunks after a deploy.
//
// Vite re-hashes chunk filenames on every build. When a new version is deployed
// while a client still has the old HTML loaded, navigating to a route whose
// lazy chunk was renamed throws "Failed to fetch dynamically imported module"
// (a hard 500 / error page). Nuxt emits `app:chunkError` for exactly this case;
// reloading the app pulls fresh HTML that references the current chunks.
//
// `persistState` keeps the current route + payload across the reload so the
// navigation the user attempted still resolves. Client-only — chunk loading is
// a browser concern.
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:chunkError', () => {
    reloadNuxtApp({ persistState: true })
  })
})
